// extracted by mini-css-extract-plugin
export default {"swiper":"MainSlider_swiper__-azpD","swiper_img":"MainSlider_swiper_img__9Q1Hu","swiper_navigation":"MainSlider_swiper_navigation__9RJa0"};